import { Toaster } from "react-hot-toast";
import colors from "../styles/_colors.scss";

const toaster = (
  <Toaster
    toastOptions={{
      duration: 5000,
      position: "bottom-right",
      style: {
        background: colors.primary2,
        color: colors.primary1,
      },
      iconTheme: {
        secondary: colors.primary2,
      },
      success: {
        iconTheme: {
          primary: colors.tertiary2,
        },
      },
      error: {
        iconTheme: {
          primary: colors.error,
        },
      },
    }}
  />
);

export default toaster;